<template>
  <div class="rex-chart-slow">
    <div v-if="data.length === 0" class="slow-body">
      <NoData :message="$t('noData')"></NoData>
    </div>
    <div class="slow-body" v-else>
      <div class="rex-chart-slow-i" v-for="(j, index) in getValue" :key="index">
        <!-- <svg class="icon vm r grey link-hover cp">
            <use xlink:href="#review-list" />
          </svg> -->
        <div class="traceValue">
          <span> {{ j.value }}</span>
        </div>
        <!-- <span
              class="cp link-hover"
              v-if="item.metricName === 'endpoint_slow_traces'"
              @click="getTracePage(j)"
            >
              {{ j.name + getTraceId(j) }}
            </span>
            <span
              class="cp link-hover"
              v-if="item.metricName !== 'endpoint_slow_traces'"
            >
              {{ j.name + getTraceId(j) }}
            </span> -->

        <div
          class="cp link-hover ellipsis"
          :id="`details-link-${index}`"
          @click="clickRow(j)"
        >
          {{ j.name }}
        </div>
        <div
          class="copy-icon"
          v-tooltip:right="'Copy'"
          @click="handleClick((j.traceIds && j.traceIds[0]) || j.name)"
          :id="`copy-icon-${index}`"
        >
          <BaseIcon name="copyStripes" width="1em" height="1.156em" />
        </div>
        <!-- <rexProgress :precent="(j.value / maxValue) * 100" color="#61a8e7" /> -->
      </div>
    </div>
    <!-- <rex-sidebox v-model:show="showtrace" :fixed="true" :width="'80%'">
        <window-trace v-if="showtrace === true" @setDialog="(type) => (showtrace = type)" :current="traceIdtoshow" />
      </rex-sidebox> -->
  </div>
</template>

<script>
import rexProgress from '@/rex-components/rex-progress.vue';
import copy from '@/utils/copy';
import BaseIcon from '@/rex-components/BaseIcon.vue';
import { mapActions } from 'vuex';
import NoData from '@/rex-components/rex-no-data.vue';
import { notificationSucess } from '@/utils/notification';

export default {
  name: 'ChartSlow',
  components: { rexProgress, BaseIcon, NoData },
  data: function () {
    return {};
  },
  props: {
    data: {},
    intervalTime: {},
    type: {},
    item: {},
    i: {},
  },
  methods: {
    ...mapActions('apmState/apmCommonState', [
      'selectEndpoint',
      'selectInstance',
    ]),
    clickRow(j) {
      let params = {
        key: j.id,
        label: j.name,
      };
      let selectedEnd = {
        endpoint: params,
      };
      let selectedIns = {
        instance: params,
      };
      if (this.item.entityType === 'Endpoint') {
        this.selectEndpoint(selectedEnd);
        this.$router.push({
          name: 'endpointGraph',
        });
      } else {
        this.selectInstance(selectedIns);
        this.$router.push({
          name: 'instanceGraph',
          params: {
            instanceId: selectedIns.instance.label,
          },
        });
      }
    },
    getTraceId(i) {
      return i.traceIds && i.traceIds[0] ? ` - ${i.traceIds[0]}` : '';
    },
    handleClick(i) {
      copy(i);
      notificationSucess(this.$t('copied'));
    },
    getTracePage(trace) {
      this.showtrace = true;
      this.traceIdtoshow = trace.traceIds && trace.traceIds[0];
    },
  },
  computed: {
    getValue() {
      const val = this.item.sortOrder;

      switch (val) {
        case 'DES':
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.data.length && this.data.sort((a, b) => b.value - a.value);

          break;
        case 'ASC':
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.data.length && this.data.sort((a, b) => b.value - a.value);

          break;
        default:
          break;
      }
      if (this.data.length > 5) {
        return this.data.slice(0, 5);
      }
      return this.data;
    },
    maxValue() {
      if (!this.data.length) {
        return null;
      }
      const temp = this.data.map((i) => i.value);
      return Math.max.apply(null, temp);
    },
  },
};
</script>
<style lang="scss" scoped>
.rex-chart-slow {
  //font-size: 0.8125rem;
  //   line-height: 0.375rem;
  height: 100%;
  width: 100%;
  .calls {
    display: inline-block;
    background-color: transparent;
    color: rgb(192, 152, 248);
    border-radius: 0.25rem;
  }
}
.rex-chart-slow-i {
  background-color: $bg-tertiary;
  height: 3.063em;
  margin-bottom: 0.875em;
  @include flex-center-justify(space-between);
  margin: 0rem 0.625rem;
  margin-bottom: 0.875em;
}
.rex-chart-slow-i:first-child {
  margin-top: 1.18em;
}
.copy-icon {
  margin-left: auto;
  cursor: pointer;
  margin-right: 0.813em;
  @include svg-fill-pointer($color-brand-accent);
}
.traceValue {
  width: 3em;
  margin-right: 1.8em;
  color: $blue-light;
  padding-left: 4px;
  font-family: $semi-bold !important;
}

.slow-body {
  height: 17rem;
  overflow-y: auto;
}
.ellipsis {
  cursor: pointer;
}
</style>
